import './App.css';
import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from 'react';
import { motion } from 'framer-motion';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import HeroSection from './components/HeroSection';
import FeaturesAndMission from './components/FeaturesAndMission';
import StatsAndServices from './components/StatsAndServices';
import ProjectShowcase from './components/ProjectShowcase';
import WhyDifferent from './components/WhyDifferent';
import TestimonialSlider from './components/TestimonialSlider';
import ContactEnquiry from './components/ContactEnquiry';
import FinalFooter from './components/FinalFooter';
import Layout from './components/Layout';
import PageHeader from './components/PageHeader';
import AboutSlider from './components/AboutSlider';
import ServicesPage from './components/ServicesPage';
import ServiceDetail from './components/ServiceDetail';
import ContactPage from './components/ContactPage';
import aboutBg from './Assets/images/about.jpg';
import servicesBg from './Assets/images/services.jpg';
import contactBg from './Assets/images/contact.jpg';
import GlobalNavbar from './components/GlobalNavbar';

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
}

const pageVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut',
    },
  },
};

const PageWrapper = ({ children }) => (
  <motion.div
    variants={pageVariants}
    initial="hidden"
    animate="visible"
  >
    {children}
  </motion.div>
);

function App() {
  return (
    <div className="App">
      <ScrollToTop />
      
<GlobalNavbar />

      
      <Routes>
        <Route path="/" element={
          <>
            <PageWrapper>
              <HeroSection />
              <FeaturesAndMission />
              <StatsAndServices />
              <ProjectShowcase />
              <WhyDifferent />
              <TestimonialSlider />
              <ContactEnquiry />
            </PageWrapper>
            <FinalFooter />
          </>
        } />
        <Route path="/about" element={
          <Layout>
            <PageHeader title="About Us" backgroundImage={aboutBg} />
            <AboutSlider />
          </Layout>
        } />
        <Route path="/services" element={
          <Layout>
            <PageHeader title="Services" backgroundImage={servicesBg} />
            <ServicesPage />
          </Layout>
        } />
        <Route path="/services/:id" element={
          <Layout>
            <ServiceDetail />
          </Layout>
        } />
        <Route path="/contact" element={
          <Layout>
            <PageHeader title="Contact" backgroundImage={contactBg} />
            <ContactPage />
          </Layout>
        } />
      </Routes>
    </div>
  );
}

export default App;
